import React from 'react';

import { type ProviderResults } from '../../types';

import { UserPermissionProvider } from './instance-data-providers';
import { Permissions } from '../../types';
import { FlightDeckProvider as ProductConfigurationProvider } from './flight-deck-provider';

interface CommonDataProviderProps {
	cloudId?: string;
	children: (props: {
		productConfiguration: ProviderResults['productConfiguration'];
		managePermission: ProviderResults['managePermission'];
	}) => React.ReactElement<any>;
}

export default ({ cloudId, children }: CommonDataProviderProps) => {
	return (
		<ProductConfigurationProvider>
			{(productConfiguration) => (
				<UserPermissionProvider cloudId={cloudId} permissionId={Permissions.MANAGE}>
					{(managePermission) =>
						children({
							productConfiguration,
							managePermission,
						})
					}
				</UserPermissionProvider>
			)}
		</ProductConfigurationProvider>
	);
};
